import type { FC } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Col, Row } from '@crehana/ui';
import { useUITheme } from '@crehana/web';
import { DiplomaCardSkeleton } from '@crehana/web/components/Cards/DiplomaCard';
import { clsx } from 'clsx';

const DiplomaListSkeleton: FC<
  React.PropsWithChildren<{ 'data-testid'?: string }>
> = ({ 'data-testid': dataTestId }) => {
  const { isDark } = useUITheme();

  return (
    <Row gutter={16} data-testid={dataTestId}>
      {Array.from({ length: 12 }).map((_, i) => (
        <Col
          // biome-ignore lint/suspicious/noArrayIndexKey: stable list order, index key acceptable here
          key={`diploma-skeleton-${i * 1}`}
          xs={12}
          sm={6}
          md={4}
          lg={3}
          className={clsx({
            'hidden md:block': i >= 4 && i < 6,
            'hidden lg:block': i >= 6,
          })}
        >
          <DiplomaCardSkeleton isDark={isDark} />
        </Col>
      ))}
    </Row>
  );
};

export default DiplomaListSkeleton;
